import Layout from "../components/layout";
import NotFound from "../pages/404NotFound";
import AboutPage from "../pages/AboutPage";
import Blogs from "../pages/Blogs";
import BlogsDetail from "../pages/BlogsDetail";
import BrandsDetailPage from "../pages/BrandsDetailPage";
import BrandsDetailPageCategory from "../pages/BrandsDetailPageCategory";
import BrandsPage from "../pages/BrandsPage";
import Categorypage from "../pages/Categorypage";
import ComparePage from "../pages/ComparePage";
import ContactUsPage from "../pages/ContactUsPage";
import FAQPage from "../pages/FAQPage";
import HomePage from "../pages/HomePage";
import LoginPage from "../pages/LoginPage";
import PayLaterPage from "../pages/PayLaterPage";
import ProductDesc from "../pages/ProductDesc";
import ProductDetailPage from "../pages/ProductDetailPage";
import TargetedBuyPage from "../pages/TargetedBuyPage";
import UrlDetailPageCategory from "../pages/UrlDetailPageCategory";
import WorkWithUsPage from "../pages/WorkWithUsPage";
import RedirectTo from "../utils/redirectTo";
import ScrollToTop from "../utils/ScrooltoTop";

export const DESKTOP_ROUTES = [
  {
    path: "*",
    element: (
      <>
        <Layout home>
          <NotFound />
          <ScrollToTop />
        </Layout>
      </>
    ),
  },
  {
    path: "/",
    element: (
      <>
        <Layout home>
          <HomePage />
          <ScrollToTop />
        </Layout>
      </>
    ),
  },
  {
    path: "/faq",
    element: (
      <>
        <Layout home>
          <FAQPage />
          <ScrollToTop />
        </Layout>
      </>
    ),
  },
  {
    path: "/work-with-us",
    element: (
      <>
        <Layout>
          <WorkWithUsPage />
          <ScrollToTop />
        </Layout>
      </>
    ),
  },
  {
    path: "/brands",
    element: (
      <>
        <Layout>
          <BrandsPage />
          <ScrollToTop />
        </Layout>
      </>
    ),
  },

  {
    path: "/blogs",
    element: (
      <>
        <Layout>
          <Blogs />
          <ScrollToTop />
        </Layout>
      </>
    ),
  },
  {
    path: "/blogs/:name",
    element: (
      <>
        <Layout>
          <BlogsDetail />
          <ScrollToTop />
        </Layout>
      </>
    ),
  },
  {
    path: "/compare",
    element: (
      <>
        <Layout>
          <ComparePage />
          <ScrollToTop />
        </Layout>
      </>
    ),
  },
  {
    path: "/about",
    element: (
      <>
        <Layout>
          <AboutPage />
          <ScrollToTop />
        </Layout>
      </>
    ),
  },
  {
    path: "/targeted-buy",
    element: (
      <>
        <Layout>
          <TargetedBuyPage />
          <ScrollToTop />
        </Layout>
      </>
    ),
  },
  {
    path: "/contact",
    element: (
      <>
        <Layout>
          <ContactUsPage />
          <ScrollToTop />
        </Layout>
      </>
    ),
  },
  {
    path: "/pay-later",
    element: (
      <>
        <Layout>
          <PayLaterPage />
          <ScrollToTop />
        </Layout>
      </>
    ),
  },
  {
    path: "/category",
    element: (
      <>
        <RedirectTo to={"/"} />
      </>
    ),
  },
  {
    path: "/story",
    element: <></>,
  },
  {
    path: "/discounted",
    element: <></>,
  },
  {
    path: "/chat",
    element: <></>,
  },
  {
    path: "/:category/:brand/:name/:vehicle_number",
    element: (
      <>
        <Layout>
          <ProductDetailPage />
          <ScrollToTop />
        </Layout>
      </>
    ),
  },

  {
    path: "/brands/:name",
    element: (
      <>
        <Layout>
          <BrandsDetailPage />
          <ScrollToTop />
        </Layout>
      </>
    ),
  },
  {
    path: "/:category/:brand",
    element: (
      <>
        <Layout>
          <BrandsDetailPageCategory />
          <ScrollToTop />
        </Layout>
      </>
    ),
  },
  {
    path: "/:category/:brand/:name",
    element: (
      <>
        <Layout>
          <UrlDetailPageCategory />
          <ScrollToTop />
        </Layout>
      </>
    ),
  },
  {
    path: "/:category",
    element: (
      <>
        <Layout>
          <Categorypage />
          <ScrollToTop />
        </Layout>
      </>
    ),
  },
  {
    path: "/brands/:brand/:model",
    element: (
      <>
        <Layout>
          <ProductDesc />
          <ScrollToTop />
        </Layout>
      </>
    ),
  },
  {
    path: "/auth/login",
    element: (
      <>
        <Layout>
          <LoginPage />
          <ScrollToTop />
        </Layout>
      </>
    ),
  },
];
